import { Skeleton } from '@/components/ui/skeleton';

/**
 * Shared Suspense fallback for lazy-loaded route modules. Re-homed from
 * `AdminDashboardPage.tsx` so every route's `<Suspense>` wraps the same
 * skeleton shape and the admin surface isn't the only place that owns it.
 */
export function TabFallback() {
  return (
    <div className="flex flex-col gap-3 py-6">
      <Skeleton className="h-9 w-full max-w-md" />
      <Skeleton className="h-72 w-full" />
    </div>
  );
}
